<app-area-gate-log-administration></app-area-gate-log-administration>
